import React from 'react';
import PropTypes from 'prop-types';
import { If, Then } from 'react-if';
import { Container, Row, Navbar } from 'reactstrap';
import classNames from 'classnames';
import './styles.css';
import { IS_SIDEKICK_APP, IS_VALIDATE_APP } from '../../../constants/projects';
import { Outlet } from 'react-router-dom';
import { useAuth } from '../../../hooks/useAuth';
import AppLoader from '../../appLoader/AppLoader';

const UnauthorizedLayout = () => {
    const { authLoading } = useAuth();

    return (
        <>
            {!authLoading ? (
                <div
                    className={classNames({
                        'unauthorized--sidekick': IS_SIDEKICK_APP,
                        unauthorized: IS_VALIDATE_APP,
                    })}
                >
                    <If condition={IS_VALIDATE_APP}>
                        <Then>
                            <div className="unauthorized-header">
                                <Container>
                                    <Row>
                                        <Navbar>
                                            <a
                                                href="https://validate.biz/"
                                                className="logo-black"
                                                rel="home"
                                            >
                                                <img
                                                    src="https://validate.biz/wp-content/uploads/2020/04/Asset-4@2x.png"
                                                    width="125"
                                                    height="30"
                                                    alt="Validate"
                                                />
                                            </a>
                                        </Navbar>
                                    </Row>
                                </Container>
                            </div>
                        </Then>
                    </If>
                    <div
                        className={classNames({
                            'sidekick-container': IS_SIDEKICK_APP,
                        })}
                    >
                        <Outlet />
                    </div>
                    <div className="unauthorized__slogan--sidekick">
                        ”Alone we can do little. <b>Together, we can do so much</b>”
                    </div>
                </div>
            ) : (
                <div className="posts__title-container-outer">
                    <div className="height-full align-items-center d-flex justify-content-center posts__title">
                        <AppLoader />
                    </div>
                </div>
            )}
        </>
    );
};

UnauthorizedLayout.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

export default React.memo(UnauthorizedLayout);
